export const getLockTargetEl = (name: string): HTMLElement | null => {
  let target: HTMLElement | null = name && name !== 'body' ? document.querySelector(`#${name}`) : document.querySelector('body')
  return target
}